import { render, staticRenderFns } from "./bookDownload.vue?vue&type=template&id=0e7ed521&"
import script from "./bookDownload.vue?vue&type=script&lang=js&"
export * from "./bookDownload.vue?vue&type=script&lang=js&"
import style0 from "./bookDownload.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports